import { createSlice } from '@reduxjs/toolkit'
import { getActiveFilters } from 'utils/helpers'

const initialState = {
  activeFilters: [] as string[],
  tableFilters: {
    search: '',
    gender: '',
    roles: [],
    created_at_from: '',
    created_at_to: '',
    birthday_from: '',
    birthday_to: '',
  },
}

export const staffUI = createSlice({
  name: 'staffUI',
  initialState: initialState,
  reducers: {
    setSearch: (state, { payload }) => {
      state.tableFilters.search = payload
    },
    setGender: (state, { payload }) => {
      state.tableFilters.gender = payload
    },
    setRoles: (state, { payload }) => {
      state.tableFilters.roles = payload
    },
    setCreatedAtFromDate: (state, { payload }) => {
      state.tableFilters.created_at_from = payload
    },
    setCreatedAtToDate: (state, { payload }) => {
      state.tableFilters.created_at_to = payload
    },
    setBirthdayFromDate: (state, { payload }) => {
      state.tableFilters.birthday_from = payload
    },
    setBirthdayToDate: (state, { payload }) => {
      state.tableFilters.birthday_to = payload
    },
    trackActiveFilters: (state: any) => {
      state.activeFilters = getActiveFilters(initialState.tableFilters, state)
    },
    clearAllFilters: (state: any) => {
      state.tableFilters = initialState.tableFilters
      state.activeFilters = []
    },
  },
})

export const {
  setSearch,
  setGender,
  setRoles,
  setCreatedAtFromDate,
  setCreatedAtToDate,
  setBirthdayFromDate,
  setBirthdayToDate,
  trackActiveFilters,
  clearAllFilters,
} = staffUI.actions

export default staffUI.reducer
